<template>
  <div class="header">



  </div>

</template>

<script>
export default {
  name: "Header",
  data() {
    return {}
  }
}


</script>

<style scoped>

</style>